import React from "react";
import { Gift } from "../../../api/giftCategories";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import DSGrid from "../../system-design/DSGrid";
import DSAvatar from "../../system-design/DSAvatar";
import { sectionCardSx } from "../../system-design/sectionCardSx";

interface OrderGiftSectionProps {
  gift: Gift;
}

const OrderGiftSection = ({ gift }: OrderGiftSectionProps) => {
  return (
    <DSBox sx={[{ mt: 3, p: 2 }, sectionCardSx]}>
      <DSTypography variant="h6" gutterBottom>
        Gift Information
      </DSTypography>
      <DSGrid container spacing={2}>
        <DSGrid item xs={12} sm={6}>
          <DSBox>
            <DSTypography variant="subtitle2" color="textSecondary">
              Gift ID
            </DSTypography>
            <DSTypography variant="body1">{gift.giftId || "-"}</DSTypography>
          </DSBox>
        </DSGrid>
        <DSGrid item xs={12} sm={6}>
          <DSBox>
            <DSTypography variant="subtitle2" color="textSecondary">
              Sender Name
            </DSTypography>
            <DSTypography variant="body1">
              {gift.senderName || "-"}
            </DSTypography>
          </DSBox>
        </DSGrid>
        <DSGrid item xs={12}>
          <DSBox>
            <DSTypography variant="subtitle2" color="textSecondary">
              Greeting Content
            </DSTypography>
            <DSTypography
              variant="body1"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {gift.greetingContent || "-"}
            </DSTypography>
          </DSBox>
        </DSGrid>
        <DSGrid item xs={12} sm={6}>
          <DSBox>
            <DSTypography variant="subtitle2" color="textSecondary">
              Klydo ID
            </DSTypography>
            <DSTypography variant="body1">{gift.klydoId || "-"}</DSTypography>
          </DSBox>
        </DSGrid>
        {gift.date && (
          <DSGrid item xs={12} sm={6}>
            <DSBox>
              <DSTypography variant="subtitle2" color="textSecondary">
                Date
              </DSTypography>
              <DSTypography variant="body1">
                {new Date(gift.date).toLocaleDateString()}
              </DSTypography>
            </DSBox>
          </DSGrid>
        )}
        {gift.senderImageUrl && (
          <DSGrid item xs={12}>
            <DSBox>
              <DSTypography variant="subtitle2" color="textSecondary">
                Sender Image
              </DSTypography>
              <DSAvatar
                src={gift.senderImageUrl}
                alt="Sender"
                sx={{ width: 100, height: 100, mt: 1 }}
              />
            </DSBox>
          </DSGrid>
        )}
      </DSGrid>
    </DSBox>
  );
};

export default OrderGiftSection;
